import React from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export const AppLayout: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const isWorkflowRoute = location.pathname.includes('/workflow/');
  const isSettingsRoute = location.pathname.startsWith('/app/settings');

  return (
    <div className="h-screen bg-gradient-to-br from-bg-primary to-bg-secondary overflow-hidden flex flex-col">
      {/* Header */}
      <div className="flex-shrink-0 bg-black bg-opacity-50 backdrop-blur-sm border-b border-border-primary">
        <div className="flex items-center justify-between p-4">
          <div className="flex items-center gap-4">
            {/* App Title */}
            <div className="flex items-center gap-2">
              <h1 className="text-lg font-semibold text-white">
                AI Agent Workflow
              </h1>
            </div>

            {/* Navigation */}
            <nav className="flex items-center gap-2">
              <button
                onClick={() => navigate('/app')}
                className={`px-3 py-1 text-sm rounded transition-colors ${
                  location.pathname === '/app' 
                    ? 'bg-primary-600 text-white' 
                    : 'text-gray-300 hover:text-white hover:bg-gray-700'
                }`}
              >
                Workflows
              </button>
            <button
              onClick={() => navigate('/app/settings')}
              className={`px-3 py-1 text-sm rounded transition-colors ${
                isSettingsRoute 
                  ? 'bg-primary-600 text-white' 
                  : 'text-gray-300 hover:text-white hover:bg-gray-700'
              }`}
            >
              Settings
            </button>
            </nav>
          </div>

          {/* User Profile */}
          {user && (
            <div className="flex items-center gap-3">
              <div className="flex items-center gap-2">
                {user.picture && (
                  <img
                    src={user.picture}
                    alt={user.name}
                    className="w-8 h-8 rounded-full border-2 border-primary-500"
                  />
                )}
                <div className="text-right">
                  <div className="text-sm font-medium text-white">{user.name}</div>
                  <div className="text-xs text-gray-400">{user.email}</div>
                </div>
              </div>
              <button
                onClick={logout}
                className="px-3 py-1 text-sm text-gray-300 hover:text-white hover:bg-gray-700 rounded transition-colors"
                title="Logout"
              >
                Logout
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        <Outlet />
      </div>

      {/* Status Bar */}
      <div className="flex-shrink-0 bg-black bg-opacity-50 backdrop-blur-sm border-t border-border-primary p-2">
        <div className="flex items-center justify-between text-sm">
          <div className="flex items-center gap-4">
            <span className="text-gray-300">
              Real AI Agent Orchestration System
            </span>
          </div>
          <div className="text-gray-400">
            {location.pathname}
          </div>
        </div>
      </div>
    </div>
  );
};
